import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackDowngrade.meta';

export type UseTrackCreditPackDowngradeParams = CreditAnalyticsParams & {
  pack_quantity: number;
  source?: OpenCreditPackModalLocations;
};

export const useTrackCreditPackDowngrade = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackDowngrade = useCallback(
    (params: UseTrackCreditPackDowngradeParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackDowngrade };
};
